import React, {useState} from 'react';
import { useSelector, useDispatch} from 'react-redux';
import { Divider, Loader, Button, Modal } from 'rsuite';
import * as actionsPolicy  from '../../../../app/actions/policy';
import NuInsStepper from '../elements/NuInsStepper';
import {steppLabels} from './common/types';
import {BackIcon} from '../svg/iconsSvg';
import {store} from '../../../../app/store';

import {generateAddressString}  from '../../../../app/common/services/vehicle.service';
import OfferCard from './OfferCard';

const Summary = ({onBack, onForward, style}) => {

    const dispatch = useDispatch();

    const { revisedOffer } = useSelector(state => state.insOffers);
    //const { insCompany, installments } = revisedOffer || {};

    const { insCompany, installments, totalAmountEUR, totalAmount, insuranceId} = revisedOffer || {}; // for testing

    //console.log(insuranceId)

    const ownerDetails   = useSelector(state => state.ownerDetails) || {};
    const {ownerAddress} = ownerDetails;
    const ownerName = ownerDetails?.companyNameCyrillic ? ownerDetails?.companyNameCyrillic : `${ownerDetails?.firstNameCyrillic} ${ownerDetails?.lastNameCyrillic}`;
    const ownerPublicId = ownerDetails?.eik ? `ЕИК ${ownerDetails?.eik}` : `ЕГН ${ownerDetails?.personPublicId}`;

    const userDetails    = useSelector(state => state.userDetails)  || {};
    const {userAddress}  = userDetails;
    const userName = `${userDetails?.firstNameCyrillic} ${userDetails?.lastNameCyrillic}`;
    const {receiverName , receiverPhone, receiverAddInfo, deliveryAddress} = useSelector(state => state.shipmentDetails) || {};

    const {registrationProps} = useSelector(state => state.insVehicleInfo) || {};
    const {make, model, plate} = registrationProps || {};
    const vechicleData = make ? `${make.value} ${model?.value} ${plate?.value}` : null;

    const [loading, setLoading] = useState(false);
    const [showFailedToCreate, setShowFailedToCreate] = useState(false)

    const goBack = () => {
        onBack(13)
    }

    const closeModal = () => setShowFailedToCreate(false);

    const goForward = async (step) => {
        setLoading(true);

         await dispatch(actionsPolicy.createOrUpdateDraftInsContract());

         const isCreatePolicyFailed = store.getState().insOffers?.createContractFailed;

         if(isCreatePolicyFailed) {
            setLoading(false);
             return setShowFailedToCreate(true);
         }

        onForward(step);
    }

    return (
        <div className="steps_container" style={style}>
            <div className="head" style={{paddingTop: '0', marginBottom: '-18px'}}>
                <div className="head-icon" style={{margin: '0 -8px 0 4px'}} onClick={goBack}><BackIcon size={32}/></div>
                <NuInsStepper activeStep={4} steps={4} labels={steppLabels}/>              
            </div>
            <Divider style={{marginBottom: 0 , backgroundColor: '#6bdfa7', height: '.5px'}}/>
            <OfferCard insCompany={insCompany} totalAmountEUR={totalAmountEUR} totalAmountLEVA={totalAmount} installments={installments} title="Избрана оферта" vechicle={vechicleData} />
            <div className="summary-container">
                <div className="left">
                    <p>Собственик</p>
                    <p>{ownerName}</p>
                    <p>{ownerPublicId}</p>
                </div>
                <div className="right">
                    <p>{generateAddressString(ownerAddress)}</p>
                </div>
            </div>
            <div className="summary-container">
                <div className="left">
                    <p>Моите данни</p>
                    <p>{userName}</p>
                    <p>ЕГН {userDetails?.userPubId}</p>
                </div>
                <div className="right">
                    <p>{generateAddressString(userAddress)}</p>
                </div>
            </div>
            <div className="summary-container" style={{marginBottom: '40px'}}>
                <div className="left">
                    <p>Доставка</p>
                    <p>{receiverName}</p>
                    <p>{'+' + receiverPhone}</p>
                </div>
                <div className="right">
                    <p>{generateAddressString(deliveryAddress)}{receiverAddInfo ? `, ${receiverAddInfo}` : ''}</p>
                </div>
            </div>

            <button className="nuIns-btn nuIns-btn-main" type="submit" onClick={()=>goForward(15)}>Плащане с карта</button>

            <button className="nuIns-btn nuIns-btn-mxd nuIns-btn-outlined_2" type="submit" onClick={()=>goForward(17)}>Наложен платеж</button>

            {loading ? <Loader backdrop center size="lg" speed="slow" /> : null}

            <Modal size="xs" show={showFailedToCreate} className="nuins-ok-modal" onHide={() => closeModal()}>
                <Modal.Body>
                    <p className="no-reg-data">Полицата не беше създадена, моля опитайте по късно</p>    
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => closeModal()} >OK</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default Summary;

